import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=61bf0063&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=61bf0063&prod&lang=less&scoped=true"
import style1 from "./QRCode.vue?vue&type=style&index=1&id=61bf0063&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf0063",
  null
  
)

export default component.exports